module.exports = __webpack_public_path__ + "static/media/jackson_pascual_dyer.8dd6a707.gif";